import React, { createContext, useContext, useEffect } from 'react';

// Theme colors
const darkTheme = {
  // Backgrounds - navbar/footer darker than main content for visual separation
  primaryBg: '#1a202c',
  secondaryBg: '#2d3748',
  tertiaryBg: '#4a5568',
  cardBg: '#2d3748', // Darker card background instead of white
  navbarBg: '#0d1117', // Darker than primaryBg for visual separation
  dropdownBg: '#4a5568',
  
  // Text colors - all light for visibility on dark backgrounds
  primaryText: '#ffffff', // Pure white for titles and main text
  secondaryText: '#e2e8f0', // Light grey for subtitles
  mutedText: '#a0aec0',
  inverseText: '#ffffff', // Pure white for navbar/footer text
  
  // Borders
  border: '#4a5568',
  borderHover: '#718096',
  
  // Interactive elements
  primary: '#4299e1',
  primaryHover: '#3182ce',
  secondary: '#4a5568',
  secondaryHover: '#718096',
  
  // Status colors
  success: '#48bb78',
  warning: '#ed8936',
  error: '#f56565',
  info: '#4299e1',
  
  // Shadows
  shadow: '0 1px 3px 0 rgba(0, 0, 0, 0.3), 0 1px 2px 0 rgba(0, 0, 0, 0.2)',
  shadowHover: '0 4px 6px -1px rgba(0, 0, 0, 0.3), 0 2px 4px -1px rgba(0, 0, 0, 0.2)',
  
  // Table colors
  tableHeaderBg: '#2d3748',
  tableRowBg: '#1a202c',
  tableRowHoverBg: '#2d3748',
  
  // Form elements
  inputBg: '#2d3748',
  inputBorder: '#4a5568',
  inputFocusBorder: '#4299e1',
  
  // Chart colors
  chartBg: '#1a202c',
  chartGrid: '#4a5568',
};

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const theme = darkTheme;

  // Apply theme to document body for global styles
  useEffect(() => {
    document.body.style.backgroundColor = theme.primaryBg;
    document.body.style.color = theme.primaryText;
  }, [theme]);

  const value = {
    theme,
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};
